import { ExecutionCalendarFormDataType } from '../schema';
import { ISODate } from '../../common/utils';

export function cloneYearDates(calendar: ExecutionCalendarFormDataType[]): {
  error?: string;
  dates: ExecutionCalendarFormDataType[];
} {
  const year = new Date().getFullYear();
  const datesByYear = filterByYear(calendar, [year, year + 1]);
  const nextYearDates = datesByYear.get(year + 1);
  const currentYearDates = datesByYear.get(year);

  if (!currentYearDates || !currentYearDates.length) {
    return { error: 'error.no-dates', dates: [] };
  }
  if (nextYearDates && nextYearDates.length > 0) {
    return { error: 'error.next-year-filled', dates: [] };
  }

  const dates: ExecutionCalendarFormDataType[] = [];
  currentYearDates.forEach((date) => {
    const [year] = date.executionDate.split('-');

    // Clone 29.02 as 28.02 to next year; add it only if 28.02 is also not selected
    if (
      isLeapDay(date.executionDate) &&
      currentYearDates.some((date) => date.executionDate === `${year}-02-28`)
    ) {
      return;
    }

    dates.push({
      ...date,
      id: null,
      executionDate: appendYear(date.executionDate),
      validPeriod: date.validPeriod.map((date) =>
        date ? appendYear(date) : null
      ) as [ISODate | null, ISODate | null],
    });
  });

  return { dates };
}

const isLeapDay = (date: ISODate) => date.endsWith('02-29');

const appendYear = (date: ISODate): ISODate => {
  const [year, month, day] = date.split('-') as [
    `${number}${number}${number}${number}`,
    `${number}${number}`,
    `${number}${number}`
  ];
  const nextYear = (
    Number(year) + 1
  ).toString() as `${number}${number}${number}${number}`;
  return `${nextYear}-${month}-${isLeapDay(date) ? '28' : day}`;
};

function filterByYear(
  calendar: ExecutionCalendarFormDataType[],
  years: number[]
) {
  const yearMap = new Map(
    years.map((year) => [year, [] as ExecutionCalendarFormDataType[]])
  );
  calendar.forEach((date) => {
    const year = Number(date.executionDate.substring(0, 4));
    if (year && yearMap.has(year)) {
      yearMap.get(year)?.push(date);
    }
  });

  return yearMap;
}
